var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowBackwardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.19531 18.0156L9.97656 17.2734C10.1719 17.0781 10.1719 16.7656 9.97656 16.6094L3.92188 10.5156H17.2812C17.5156 10.5156 17.75 10.3203 17.75 10.0469V8.95312C17.75 8.71875 17.5156 8.48438 17.2812 8.48438H3.92188L9.97656 2.42969C10.1719 2.27344 10.1719 1.96094 9.97656 1.76562L9.19531 1.02344C9.03906 0.828125 8.72656 0.828125 8.53125 1.02344L0.367188 9.1875C0.171875 9.38281 0.171875 9.65625 0.367188 9.85156L8.53125 18.0156C8.72656 18.2109 9.03906 18.2109 9.19531 18.0156Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBackwardIcon);
export default __webpack_public_path__ + "static/media/arrow-backward-icon.b3a11c78.svg";
export { ForwardRef as ReactComponent };